import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) top / cover no-repeat`}
          column
          alignCenter
        >
          {/* <Header /> */}
          <CFView textCenter w="100%" mt="35px">
            <CFView>
              <CFImage
                w="95%"
                src={mobileHeroText}
                alt="Sushi wara hero text"
                zIndex={98}
              />
            </CFView>
            <CFView pulsate mt="30px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyStart
          alignStart
        >
          {/* <Header /> */}
          <CFView column justifyCenter alignStart mt="150px" ml="50px">
            <CFImage
              w="550px"
              src={heroText}
              alt="Sushi wara hero text"
              zIndex={98}
            />
            <CFView pulsate mt="50px" ml="35px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
